module.exports = __webpack_public_path__ + "img/01_WALZE_Image_1-16366.f9c7b1b8.jpg";